import React from 'react';
import { useIsFocused } from '@react-navigation/native';

/**
 * HOC that will only render children when the screen is focused by react-navigation.
 */
function withOnlyMountOnFocus<P extends React.JSX.IntrinsicAttributes>(WrappedComponent: React.ComponentType<P>) {
    // This is the new component that wraps the original component
    const ComponentWithFocusCheck = (props: P) => {
        const isFocused = useIsFocused();

        // Render the wrapped component only if the screen is focused
        return isFocused ? <WrappedComponent {...props} /> : null;
    };

    // Give this component a more useful display name in DevTools
    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithFocusCheck.displayName = `withFocusCheck(${wrappedComponentName})`;

    return ComponentWithFocusCheck;
}

export default withOnlyMountOnFocus;
